import {
  resourceState,
  resourceMutations,
  resourceGetters,
  resourceActions,
} from '@/store/utils/resource';
import { APPROVAL_REQUESTS } from '@/store/entities/schema_types';
import { projectAssetApprovalRequestsClient as client } from '@/api/clients';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  getters: resourceGetters('approvalRequests'),
  actions: {
    ...resourceActions,
    async load(ctx, { projectAssetId, query = {} }) {
      try {
        const response = await client.list(projectAssetId, query);

        const { data } = response;

        const ids = await ctx.dispatch(
          'entities/persistEntities',
          { type: APPROVAL_REQUESTS, data },
          { root: true }
        );

        ctx.commit({
          type: 'setIdsByParent',
          parentId: projectAssetId,
          ids,
        });

        return Promise.resolve(true);
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
  },
};
